<template>
  <div v-if="showModal" class="side__modal opened" id="modal__adding__customers__docs">
    <div class="">
      <div class="side__modal__content">
        <div class="modal__top">
          <div class="modal__header">
            <h3 class="modal__title">{{ $lang.app.PROJECT_MAIN_ARCHITECT }}</h3>
            <span class="modal__close" @click="closeModal">
            <svg viewBox="0 0 20 20" width="20" height="20"><use xlink:href="@/assets/v2/img/sprite.svg#modal__close"></use></svg></span>
          </div>
        </div>

        <Form class="modal__footer"
              @submit="submit"
              :initial-values="projectArchitectForm"
              :validation-schema="projectArchitectSchema">

          <div class="row">
            <div class="col-lg-6">
              <div class="input__group">
                <label for="surname-input" class="label">{{ $lang.app.SURNAME }} <span class="text-red-500">*</span></label>
                <Field name="surname" v-slot="{ field, errorMessage }">
                  <input v-bind="field"
                         type="text"
                         id="surname-input"
                         v-model="projectArchitectForm.surname"
                         class="input"
                         :class="{'input--fail': errorMessage }"
                         :placeholder="$lang.app.ENTER">
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="input__group">
                <label for="name-input" class="label">{{ $lang.app.NAME }} <span class="text-red-500">*</span></label>
                <Field name="name" v-slot="{ field, errorMessage }">
                  <input v-bind="field"
                         type="text"
                         id="name-input"
                         v-model="projectArchitectForm.name"
                         class="input"
                         :class="{'input--fail': errorMessage }"
                         :placeholder="$lang.app.ENTER">
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <div class="input__group">
                <label for="patronymic-input" class="label">{{ $lang.app.PATRONYMIC }}</label>
                <Field name="patronymic" v-slot="{ field, errorMessage }">
                  <input v-bind="field"
                         type="text"
                         id="patronymic-input"
                         v-model="projectArchitectForm.patronymic"
                         class="input"
                         :class="{'input--fail': errorMessage }"
                         :placeholder="$lang.app.ENTER">
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="input__group">
                <label for="cert-number-input" class="label">{{ $lang.app.CERTIFICATE_NUMBER_LICENSES }} <span class="text-red-500">*</span></label>
                <Field name="certNumber" v-slot="{ field, errorMessage }">
                  <input v-bind="field"
                         type="text"
                         id="cert-number-input"
                         v-model="projectArchitectForm.certNumber"
                         class="input"
                         :class="{'input--fail': errorMessage }"
                         :placeholder="$lang.app.ENTER">
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
            </div>
          </div>

          <div class="input__groups">
            <label for="files-input" class="label label__file mb-4">
              <span v-if="projectArchitectForm.files">{{ projectArchitectForm.files.name }}</span>
              <span v-else>
              <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
                <use xlink:href="@/assets/v2/img/sprite.svg#icon__plus"></use>
              </svg>
            {{ $lang.app.FILE_CERTIFICATE_LICENSES }} <span class="text-red-500">*</span>
            </span>
            </label>
            <Field type="file" name="files" accept="application/pdf,text/rtf,application/vnd.ms-excel,application/msword,image/jpeg,application/xml"
                   id="files-input"
                   class="input__file hidden"
                   @change="event => projectArchitectForm.files = event.target.files[0]"/>
            <ErrorMessage name="files" class="input__fail"/>
          </div>

          <div class="row">
            <div class="col-lg-6">
              <div class="input__group">
                <label for="phone-number-input" class="label">{{ $lang.app.PHONE }}</label>
                <Field name="phoneNumber" v-slot="{ field, errorMessage }">
                  <input v-bind="field"
                         type="text"
                         id="phone-number-input"
                         v-model="projectArchitectForm.phoneNumber"
                         class="input"
                         :class="{'input--fail': errorMessage }"
                         :placeholder="$lang.app.ENTER">
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="input__group">
                <label for="email-input" class="label">{{ $lang.app.EMAIL }}</label>
                <Field name="email" v-slot="{ field, errorMessage }">
                  <input v-bind="field"
                         type="text"
                         id="email-input"
                         v-model="projectArchitectForm.email"
                         class="input"
                         :class="{'input--fail': errorMessage }"
                         :placeholder="$lang.app.ENTER">
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
            </div>
          </div>

          <div class="between__buttons">
            <button type="button" class="button button__modal__close button--cancel"
                    @click="closeModal">{{ $lang.app.CANCEL }}</button>
            <button type="submit" class="relative button button__modal__close"
                    :disabled="submitting">
              {{ $lang.app.UPDATE }}
              <div v-if="submitting" class="loading-blue text-white absolute z-10 w-full rounded-lg h-full top-0 left-0 flex items-center justify-center">
                <div class="block animate-spin">
                  <RefreshIcon class="w-6 h-6 mirror-y"/>
                </div>
              </div>
            </button>
          </div>

        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import * as yup from "yup";
import {Field, Form, ErrorMessage} from 'vee-validate';
import applicationApi from "../../../../api/applicant/application";
import fileMixin from "../../../../mixins/fileMixin";

export default {
  name: 'ApplicantApplicationArchitectEditModal',
  props: {
    application: Object,
  },
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  mixins: [fileMixin],
  data() {
    return {
      showModal: false,
      projectDeveloper: null,

      projectArchitect: null,

      submitting: false,

      projectArchitectForm: {
        name: '',
        surname: '',
        patronymic: '',
        certNumber: '',
        phoneNumber: '',
        email: '',
        files: null,
      },

      projectArchitectSchema: yup.object({
        surname: yup.string().required(),
        name: yup.string().required(),
        certNumber: yup.string().required(),
      }),
    }
  },
  beforeMount() {
    this.$emitter.on('open-applicant-application-architect-edit-modal', (payload) => {
      this.projectDeveloper = payload.projectDeveloper
      this.projectArchitect = payload.projectArchitect
      this.projectArchitectForm = {
        name: payload.projectArchitect.name,
        surname: payload.projectArchitect.surname,
        patronymic: payload.projectArchitect.patronymic,
        certNumber: payload.projectArchitect.certNumber,
        phoneNumber: payload.projectArchitect.phoneNumber,
        email: payload.projectArchitect.email,
      }

      this.loadProjectArchitectFile(this.projectDeveloper, this.projectArchitect)

      this.openModal()
    })
  },
  beforeUnmount() {
    this.$emitter.off('open-applicant-application-architect-edit-modal')
  },
  methods: {
    openModal() {
      this.showModal = true
      this.$emitter.emit('body-unscrollable')
    },
    closeModal() {
      this.showModal = false
      this.$emitter.emit('body-scrollable')
    },
    loadProjectArchitectFile(projectDeveloper, projectArchitect) {
      applicationApi
          .getProjectArchitectFile(projectDeveloper.id, projectArchitect.id)
          .then((res) => {
            this.projectArchitect.files = res.data
          })
          .catch((error) => {
            this.$snotify.error(error);
          })
    },
    async submit(values, actions) {
      this.submitting = true
      applicationApi.updateProjectArchitect(this.projectDeveloper.id,this.projectArchitect.id, {
        ...this.projectArchitectForm,
        files: this.projectArchitectForm.files ? {
          filename: this.projectArchitectForm.files.name,
          fileData: await this.getBase64(this.projectArchitectForm.files),
        } : {
          filename: this.projectArchitect.files.filename,
          fileData: this.projectArchitect.files.base64,
        }
      })
          .then(() => {
            this.closeModal()
            this.$emitter.emit('refresh-application', {reload: false})
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.setValidationErrors(actions, error.response.data.errors)
              this.$snotify.error(error.response.data.message)
            } else {
              this.$snotify.error(error)
            }
          }).finally(() => {
            this.submitting = false
      })
    }
  }
}
</script>
